import styled from 'styled-components';
import { device } from '../../../constants';

export const LogoIcon = styled.img`
  width: 158px;
  height: 40px;

  @media ${device.laptop} {
    width: 96px;
    height: 96px;
  }
`;

export const FooterContainer = styled.div`
  background-color: ${({ theme }) => theme.colors['background-03']};

  :is([data-theme='dark'] &) {
    background-color: ${({ theme }) => theme.colors['background-02']};
  }
`;

export const FooterWrapper = styled.footer`
  width: 100%;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media ${device.laptop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: initial;
    padding: 40px 24px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  @media ${device.laptop} {
    align-items: flex-start;
    gap: 16px;
  }
`;

export const SectionTitle = styled.h5`
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-07']};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1.6px;

  @media ${device.laptop} {
    font-size: 16px;
    line-height: 24px;
  }

  :is([data-theme='dark'] &) {
    color: ${({ theme }) => theme.colors['neutral-01']};
  }
`;

export const Address = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors['neutral-07']};
  margin: 0;
  line-height: 16px;
  font-weight: 400;

  @media ${device.laptop} {
    font-size: 14px;
    line-height: 20px;
  }

  :is([data-theme='dark'] &) {
    color: ${({ theme }) => theme.colors['neutral-01']};
  }
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media ${device.laptop} {
    align-items: flex-start;
    gap: 20px;
  }
`;

export const FooterLink = styled.a`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1.2px;
  color: ${({ theme }) => theme.colors['neutral-07']};
  text-decoration: underline;

  @media ${device.laptop} {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 1.4px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors['branding-01']};
  }

  :is([data-theme='dark'] &) {
    color: ${({ theme }) => theme.colors['neutral-01']};

    &:hover {
      color: ${({ theme }) => theme.colors['branding-01']};
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  @media ${device.laptop} {
    margin-top: 8px;
    justify-content: space-between;
    width: 100%;
    max-width: 128px
  }
`;

export const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  
  svg {
    width: 32px;
    height: 32px;
  }

  @media ${device.laptop} {
    svg {
      width: 40px;
      height: 40px;
    }
  }
`;

export const GptwImage = styled.img`
  display: none;

  @media ${device.laptop} {
    display: block;
    width: 60px;
  }
`;

export const Copyright = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors['branding-02']};
  color: ${({ theme }) => theme.colors['neutral-01']};
  font-size: 12px;
  line-height: 100%;
  font-weight: 400;

  :is([data-theme='dark'] &) {
    background-color: ${({ theme }) => theme.colors['background-02']};
    color: #c0c0c0;
    font-size: 16px;
    line-height: 20px;
    border-top: 1px solid #7b7b7b;
  }
`; 